import { useEffect, useRef } from 'react';
import { useCart } from '@/context/CartContext';

const heroImage = '/img/hero-macaverde-01.jpg';

const whatsappNumber = '55999260502';

function HeroSection() {
  const { setIsOpen } = useCart();
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.querySelectorAll('.hero-animate').forEach((el) => {
              el.classList.add('animate-in');
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="inicio"
      ref={sectionRef}
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="Crianças felizes usando roupas Maçã Verde"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-8 py-20 md:py-24">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="hero-animate font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 opacity-0 translate-y-6 transition-all duration-700">
            Moda infantil com
            <br />
            conforto, estilo e carinho
          </h1>
          <p className="hero-animate text-base md:text-lg text-white/90 mb-8 max-w-xl mx-auto opacity-0 translate-y-6 transition-all duration-700 delay-150">
            Conheça as coleções da Maçã Verde e escolha as peças favoritas para os pequenos.
          </p>
          <div className="hero-animate flex flex-col sm:flex-row items-center justify-center gap-3 opacity-0 translate-y-6 transition-all duration-700 delay-300">
            <a
              href="#catalogo"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#catalogo')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-600 text-white font-medium hover:bg-primary-700 transition-colors whitespace-nowrap"
            >
              Ver catálogo
              <i className="ri-arrow-right-line" />
            </a>
            <button
              type="button"
              onClick={() => setIsOpen(true)}
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white text-primary-700 font-medium hover:bg-white/90 transition-colors whitespace-nowrap"
            >
              <i className="ri-shopping-bag-line" />
              Finalizar pelo WhatsApp
            </button>
          </div>
        </div>
      </div>

      <style>{`
        .hero-animate.animate-in {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}

export default HeroSection;